__turbopack_context__.v({
  "results": "publications-search-module-scss-module__Nzq6gq__results",
});
